<template>
  <div class="policy" :class="[
    !pendencyLoading
      ? (reversedReplies[0] && reversedReplies[0].status
        ? `pendency--status--${reversedReplies[0].status.id}`
        : `pendency--status--${status.id}`)
      : null,
    { 'policy--expanded': showMoreDetails },
  ]">

    <Loading v-if="pendencyLoading" />
    <template v-else>
      <div class="row row--policy box box--default" :class="{ 'row--active': showMoreDetails }">
        <div class="row__data row__data--medium row__data ">
          {{ pendency.id }}
        </div>
        <div class="row__data row__data--medium row__data--fixed" :class="{ 'row__data--underline': canEditPendency }">
          <span v-if="canEditPendency" @click="showStatusPopup = true" style="cursor: pointer">
            <transition name="fade" mode="in-out">
              <PopupEditer v-if="showStatusPopup" @togglePopup="showStatusPopup = $event" :items="statuses"
                :selected="pendencyStatus" :label="'name'" @submit="updatePendencyStatus($event)" />
            </transition>
            {{ status.name }}
          </span>

          <span v-else>
            {{ status.name }}
          </span>
        </div>

        <div class="row__data row__data--large row__data ">
          <p v-if="pendency.title">{{ pendency.title }}</p>
          <p v-else>
            ----
          </p>
        </div>

        <div class="row__data row__data--medium row__data ">
          <p v-if="policy && policy.policy_number !== null">{{ policy.policy_number }}
          </p>
          <p v-else>
            ----
          </p>
        </div>

        <div class="row__data row__data--medium row__data ">
          <p v-if="policy">{{ formatDate(policy.created_at) }}</p>
          <p v-else>
            ----
          </p>
        </div>

        <div class="row__data row__data--large policy__company">
          <p v-if="company">{{ company }}</p>
          <p v-else>
            ----
          </p>
        </div>
        <div class="row__data row__data--medium">
          <p v-if="branch">{{ branch }}</p>
          <p v-else>
            ----
          </p>
        </div>
        <div class="row__data row__data--medium" :class="{ 'row__data--underline': canEditPendency }">
          <span v-if="canEditPendency" @click="showAgentPopup = true;" style="cursor: pointer">
            <transition name="fade" mode="in-out">
              <PopupEditer v-if="showAgentPopup" @togglePopup="showAgentPopup = $event" :items="agents"
                :selected="agent" :position="'left'" :label="['first_name', 'last_name']"
                @submit="updatePolicyAgent($event)" />
            </transition>
            {{ agent }}
          </span>

          <span v-else>
            {{ agent }}
          </span>
        </div>

        <div class="row__data row__data--medium row__data--half row__data--last">
          <div class="row__data row__data--small row__data--pdf icon"
            :class="hasFiles ? 'icon__pdf--active' : 'icon__pdf'"
            @click="canAccessPendencyFiles && openPendencyFilesModal()"></div>

          <div class="row__data row__data--small row__data--more" :class="{ 'row__data--rotate': showMoreDetails }"
            @click="showMoreDetails = !showMoreDetails">
          </div>
        </div>
      </div>
      <div class="policy__services" :class="{ 'policy__services--expand': showMoreDetails }">

        <div class="services" ref="services" :style="showMoreDetails
          ? { maxHeight: `${manualHeight}px` }
          : { maxHeight: 0 }
          " :class="{ 'services--expand': showMoreDetails }">
          <div class="services__no-data" v-if="!pendency">
            {{ $t(`pendenciesTable.${"noServicesMsg"}`) }}
          </div>
          <template v-else>
            <div class="table__header table__header--inner">
              <div class="table__label table__label sender-label">
                {{ $t(`pendenciesTable.${"sender"}`) }}
              </div>

              <div class="table__label table__label beschreibung-label">
                {{ $t(`pendenciesTable.${"description"}`) }}
              </div>

              <div class="table__label table__label deadline-reciever-label medium-label">
                {{ $t(`pendenciesTable.${"deadline"}`) }} / {{ $t(`pendenciesTable.${"receiver"}`) }}
              </div>

              <div class="table__label table__label status-label medium-label">
                {{ $t(`pendenciesTable.${"status"}`) }}
              </div>

              <div class="table__label table__label tools-label "> {{ $t(`pendenciesTable.${"tools"}`) }}</div>

              <div class="table__label table__label dropdown-label"></div>
            </div>

            <PendencyService :service="pendency" :replies="pendency.replies" :policy="pendency.policy"
              :agent="pendency.agent" :created="pendency.created_at" :description="pendency.description"
              :deadline="pendency.deadline" :receiver="pendency.customer" :status="pendency.status" :offer="offer"
              @toggle-replies="recalculateHeight" />
          </template>
        </div>


      </div>
    </template>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, nextTick, watch } from "vue";
import { useStore } from "vuex";
import statics from "@/statics";
import PendencyService from "@/components/AccountDetails/PendencyService";
import PopupEditer from "@/partials/PopupEditer";
import Loading from "@/partials/Loading";
import { extractEntityTeamIds } from "@/helpers/teamAuthorization";

defineOptions({
  name: "Pendency"
});

const props = defineProps({
  pendency: { required: true, type: Object },
  statuses: { required: true, type: Array },
  agents: { required: false, type: Array },
  expandedPendencyId: { type: Number, required: false },
  offer: { type: Array, required: false },
});

const store = useStore();

// State
const showMoreDetails = ref(false);
const showStatusPopup = ref(false);
const showAgentPopup = ref(false);
const pendencyLoading = ref(false);
const manualHeight = ref(0);

// Template Refs

// Computed
const reversedReplies = computed(() =>
  [...(props.pendency?.replies || [])].reverse()
);

const company = computed(() =>
  policy.value ? (policy.value.company.full_name || statics.empty) : statics.empty
);

const branch = computed(() => {
  if (policy.value && policy.value.policy_services.length) {
    return policy.value.policy_services[0].service.branch_category.name || statics.empty;
  }
  return null;
});

const agent = computed(() =>
  props.pendency?.agent
    ? `${props.pendency.agent.first_name || statics.empty} ${props.pendency.agent.last_name || statics.empty}`
    : statics.empty
);

const isSuperAdmin = computed(() => store.getters.isSuperAdmin);
const policy = computed(() => props.pendency?.policy);
const pendencyTargetTeams = computed(() => extractEntityTeamIds(
  props.pendency?.customer
  ?? policy.value?.customer
  ?? store.getters.customer
  ?? props.pendency
  ?? {}
));
const canEditPendency = computed(() => {
  if (isSuperAdmin.value) return true;
  return pendencyTargetTeams.value.length > 0
    ? store.getters.canPerformActionOnEntity("pendency_edit", pendencyTargetTeams.value)
    : false;
});

const canAccessPendencyFiles = computed(() => {
  const value = isSuperAdmin.value
    ? true
    : pendencyTargetTeams.value.length > 0
      ? store.getters.canPerformActionOnEntity("pendency_edit", pendencyTargetTeams.value)
      : false;
  return value;
});

const status = computed(() => props.pendency.status);

const pendencyStatus = computed(() => props.pendency.status ? props.pendency.status.name : statics.empty);

// const pendencyStatusColor = computed(() => {
//   if (!policy.value) return null;
//   const index = statics.policyStatuses.findIndex((s) => policy.value.company.status === s.id);
//   return index !== -1 ? statics.policyStatuses[index].name : null;
// });

const hasFiles = computed(() => {
  const pendencyHas = Array.isArray(props.pendency?.files)
    ? props.pendency.files.length > 0
    : false;

  let offerHas = false;
  if (props.offer) {
    offerHas = Array.isArray(props.offer)
      ? props.offer.some((o) => Array.isArray(o?.files) && o.files.length > 0)
      : Array.isArray(props.offer.files) && props.offer.files.length > 0;
  }

  return pendencyHas || offerHas;
});

// Lifecycle
const services = ref(null);

onMounted(() => {
  nextTick(() => {
    if (services.value) {
      manualHeight.value = services.value.scrollHeight;
    }

    if (props.pendency.id == props.expandedPendencyId) {
      showMoreDetails.value = true;
      nextTick(() => {
        if (services.value) {
          manualHeight.value = services.value.scrollHeight;
        }
      });
    }
  });
});

watch(showMoreDetails, async (value) => {
  if (value) {
    await nextTick();
    manualHeight.value = services.value?.scrollHeight || 1000;
  } else {
    manualHeight.value = 0;
  }
});

// Methods
const recalculateHeight = () => {
  nextTick(() => {
    setTimeout(() => {
      if (services.value) {
        manualHeight.value = services.value.scrollHeight;
      }
    }, 50);
  });
};

const updatePendencyStatus = async (pendencyStatusId) => {
  if (!canEditPendency.value) return;

  pendencyLoading.value = true;
  await store.dispatch("updatePendencyStatus", {
    pendencyId: props.pendency.id,
    pendencyStatusId,
  });
  showStatusPopup.value = false;
  pendencyLoading.value = false;
};

const updatePolicyAgent = async (agentId) => {
  if (!canEditPendency.value) return;

  pendencyLoading.value = true;
  await store.dispatch("updatePolicyAgent", {
    pendencyId: props.pendency.id,
    agentId,
  });
  showAgentPopup.value = false;
  pendencyLoading.value = false;
};

const formatDate = (dateString) => {
  if (!dateString) return '';
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  return `${day}.${month}.${year}`;
};

const openPendencyFilesModal = () => {
  if (!canAccessPendencyFiles.value) return;

  const files = [];
  if (Array.isArray(props.pendency?.files)) files.push(...props.pendency.files);

  const addOfferFiles = (offer) => {
    if (!offer?.id) return;

    files.push({
      id: `${offer.policy_offer_code}-Offerte_${offer.id}`,
      name: `${offer.policy_offer_code}-Offerte.pdf`,
      file_name: `${offer.policy_offer_code}-Offerte.pdf`,
      created_at: offer.created_at,
      isDownloadable: true,
      offerId: offer.id,
    });

    if (Array.isArray(offer.files)) {
      files.push(...offer.files);
    }
  };

  const offerItems = Array.isArray(props.offer) ? props.offer : (props.offer ? [props.offer] : []);
  offerItems.forEach(addOfferFiles);

  store.commit("setFilesToEditId", props.pendency.id);
  store.commit("setFilesToEdit", files);
  store.commit("setFilesToEditOffers", offerItems);
  store.commit("setFilesEditMode", 'Pendencies');
  store.commit("setShowFilesEditModal", true);
};
</script>

<style lang="scss" scoped>
.table {
  &__header {
    padding-left: 15px;
  }

  &__label {
    padding: 0;
    text-align: left;
  }
}

.sender-label {
  width: 22%;
}

.beschreibung-label {
  width: 35%;
}

.medium-label {
  width: 14%;
  text-align: center;
}

.tools-label {
  width: 12%;
  text-align: center;
}

.dropdown-label {
  width: 3%;
}



.pendency--status--1::before {
  background-color: #ff3333;
}

.pendency--status--2::before {
  background-color: #FF9E0F;
}

.pendency--status--3::before {
  background-color: #22db8e;
}
</style>
